import { render, staticRenderFns } from "./createAssociation.vue?vue&type=template&id=0d886b30&scoped=true"
import script from "./createAssociation.vue?vue&type=script&lang=js"
export * from "./createAssociation.vue?vue&type=script&lang=js"
import style0 from "./createAssociation.vue?vue&type=style&index=0&id=0d886b30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d886b30",
  null
  
)

export default component.exports